import React from 'react'
import useLanguageStore from '../stores/language/languageStore'
import useLanguageStoreFunction from '../stores/language/languageAction'
import { useTranslation } from 'react-i18next'
import languageKey from './languageKey'
const useTranslate = () => {
    const { t, i18n } = useTranslation()
    const languageStore = useLanguageStore()
    const languageAction = useLanguageStoreFunction()

    const get = (key: string, replaceWords?: Array<string>): string => {
        let resourcesWord = t(key)
        if (replaceWords !== undefined && replaceWords !== null) {
            replaceWords.forEach((text, index) => {
                resourcesWord = resourcesWord.replace('{' + index + '}', text)
            })
        }

        return resourcesWord
    }
    const get2Element = (key: string, replaceWords?: Array<string>): HTMLElement => {
        let resourcesWord = t(key)
        if (replaceWords !== undefined && replaceWords !== null) {
            replaceWords.forEach((text, index) => {
                resourcesWord = resourcesWord.replace('{' + index + '}', text)
            })
        }
        const element = React.createElement('label', { dangerouslySetInnerHTML: { __html: resourcesWord } })
        //@ts-ignore
        return element
    }
    const setChangeLanguage = (languageKey: string) => {
        languageAction.setCurrentLanguage(languageKey)
        i18n.changeLanguage(languageKey)
    }
    return {
        //props
        languageStore,
        languageKey,

        //function
        get, //ใช้แสดง resource word
        get2Element,
        setChangeLanguage, //ใช้เปลี่ยน ภาษา
    }
}

export default useTranslate
